import Api from './Api';
import Server from './index';

class CustomAppsApi extends Api {
  url = 'customapps';

  async getReadiness(customApp, database) {
    return Server.__getRequest(`/customapps/readiness?customApp=${customApp}&database=${database}`);
  }

  /**
   * Readiness with explicit collection id map + settings (optional collections, etc.).
   * Preferred over getReadiness for Deploy Custom App.
   */
  async checkReadiness(payload) {
    return Server.__postRequest('/customapps/readiness', payload);
  }

  async createInstance(payload) {
    return Server.__postRequest('/customapps/instances', payload);
  }
}

const singleton = new CustomAppsApi();
export default singleton;
